export enum ATTACHMENT_FLAG {
    DELETABLE = 'deletable',
}

export interface Attachment {
    attachmentId?: string;
    fileName?: string;
    size?: string;
    bankMessage?: string;
    flags: ATTACHMENT_FLAG[];
}

export interface FileManagement {
    bankMessage?: string;
    attachments?: Attachment[];
}
